export default {
  placeholder: 'Veuillez introduire un(e) {field}',
  submit: {
    short: 'Enregistrer',
    long: 'Enregistrer ce(tte) %{model}',
    add: {
      short: 'Ajouter',
      long: 'Ajouter un(e) %{model}',
    },
    edit: {
      short: 'Enregistrer',
      long: 'Enregistrer ce(tte) %{model}',
    },
    create: {
      short: 'Créer',
      long: 'Créer un(e) %{model}',
    },
    update: {
      short: 'Modifier',
      long: 'Modifier ce(tte) %{model}',
    },
  },
  reset: 'Réinitialiser',
  cancel: 'Annuler',
};
